import { LIQUIDITY_STATE_LAYOUT_V4, Liquidity, LiquidityPoolKeysV4, MARKET_STATE_LAYOUT_V3, Market, SPL_MINT_LAYOUT } from '@raydium-io/raydium-sdk';
import { Connection, PublicKey } from '@solana/web3.js';

export async function formatAmmKeysByAccountData(connection: Connection, ammId: PublicKey, ammAccountData: Buffer, lpMintAccountData: Buffer, owner: PublicKey): Promise<LiquidityPoolKeysV4> {
    const info = LIQUIDITY_STATE_LAYOUT_V4.decode(ammAccountData);
    const marketAccount = await connection.getAccountInfo(info.marketId);

    if (marketAccount === null) throw Error(' get market info error');
    const marketInfo = MARKET_STATE_LAYOUT_V3.decode(marketAccount.data);
    const lpMintInfo = SPL_MINT_LAYOUT.decode(lpMintAccountData);

    return {
        id: ammId,
        baseMint: info.baseMint,
        quoteMint: info.quoteMint,
        lpMint: info.lpMint,
        baseDecimals: info.baseDecimal.toNumber(),
        quoteDecimals: info.quoteDecimal.toNumber(),
        lpDecimals: lpMintInfo.decimals,
        version: 4,
        programId: owner,
        authority: Liquidity.getAssociatedAuthority({ programId: owner }).publicKey,
        openOrders: info.openOrders,
        targetOrders: info.targetOrders,
        baseVault: info.baseVault,
        quoteVault: info.quoteVault,
        withdrawQueue: info.withdrawQueue,
        lpVault: info.lpVault,
        marketVersion: 4,
        marketProgramId: info.marketProgramId,
        marketId: info.marketId,
        marketAuthority: Market.getAssociatedAuthority({ programId: info.marketProgramId, marketId: info.marketId }).publicKey,
        marketBaseVault: marketInfo.baseVault,
        marketQuoteVault: marketInfo.quoteVault,
        marketBids: marketInfo.bids,
        marketAsks: marketInfo.asks,
        marketEventQueue: marketInfo.eventQueue,
        //lookupTableAccount: PublicKey.default,
    } as unknown as LiquidityPoolKeysV4;
}
